import { Url } from '../shared/Url';
import Post from '../shared/Post';
import PostNotif from '../shared/PostNotif';
import { consultaUser } from './PefilFunction';
import { consultaUsuario } from './ConsultaUser'
import { cookieData } from '../funciones/ConsultaUser';

export const NotifValidate = (/* emails, */ respuesta) => {
    consultaUser((usuario) => {
        let Contenido = {
            User: usuario
        }
        PostNotif(`${Url}notifValidate`, Contenido, (resp) => {
            let data = JSON.parse(resp);
            let dataicon = { icon: "", text: "" }

            if (data.cantNoti === 0) dataicon = { icon: "fa fa-times", text: "No tienes notificaciones" }

            let State = {
                cantNotif: data.cantNoti,
                iconRefresh: { icon: "fa fa-refresh", disabled: false },
                iconText: dataicon
            }
            /* if (emails.length > 0) {
                State = {cantNotif: (data.cantNoti + 1)}
            } */
            
            respuesta(State);
        });
    })
}

export const NotifValidateConEmail = (respuesta) => {
    consultaUser((usuario) => {
        let Contenido = {
            User: usuario
        }
        Post(`${Url}notifValidate`, Contenido, (resp) => {
            let data = JSON.parse(resp);
            let State = {cantNotif: data.cantNoti}
            respuesta(State);
        });
    })
}

export const Validate = (respuesta) => {
    PostNotif(`${Url}cantNotifValidate`, "", (resp) => {
        let data = JSON.parse(resp);
        let State = {cantNotifValidate: data.cantNoti}
        respuesta(State);
    });
}

export const ValidateInscrip = (respuesta) => {
    PostNotif(`${Url}cantNotifValidateInsc`, "", (resp) => {
        let data = JSON.parse(resp);
        let State = {cantNotifValidateInscrip: data.cantNoti}
        respuesta(State);
    });
}

export const ValidateCambCarrera = (respuesta) => {
    PostNotif(`${Url}cantNotifValidateCambCarrerra`, "", (resp) => {
        let data = JSON.parse(resp);
        let State = {cantNotifValidateCambCarrerra: data.cantNoti}
        respuesta(State);
    });
}

export const ValidateNotas = (respuesta) => {
    PostNotif(`${Url}cantNotifValidateNotas`, "", (resp) => {
        let data = JSON.parse(resp);
        let State = {cantNotifValidateNotas: data.cantNoti}
        respuesta(State);
    });
}

export const ValidateNotasAdmin = (respuesta) => {
    PostNotif(`${Url}cantNotifValidateNotasAdmin`, "", (resp) => {
        let data = JSON.parse(resp);
        /* console.log(resp); */
        let State = {cantNotifValidateNotasAdmin: data.cantNoti}
        respuesta(State);
    });
}

export const ValidateRetiroEst = (respuesta) => {
    PostNotif(`${Url}cantValidateRetiroEst`, "", (resp) => {
        let data = JSON.parse(resp);
        let State = {cantNotifValidateRetiro: data.cantNoti}
        respuesta(State);
    });
}


export const ValidateConstEst = (respuesta) => {
    PostNotif(`${Url}cantNotifValidateConstEst`, "", (resp) => {
        let data = JSON.parse(resp);
        let State = {cantNotifValidateConstEst: data.cantNoti}
        respuesta(State);
    });
}

export const ValidateSolEst = (respuesta) => {
    PostNotif(`${Url}cantNotifValidateSolEst`, "", (resp) => {
        let data = JSON.parse(resp);
        let State = {cantNotifValidateSolEst: data.sol
        }
        respuesta(State);
    });
}

export const ValidateConstEstAdmin = (respuesta) => {
    PostNotif(`${Url}cantNotifValidateConstEstAdmin`, "", (resp) => {
        let data = JSON.parse(resp);
        let State = {cantNotifValidateConstEstAdmin: data.cantNoti}
        respuesta(State);
    });
}

export const ValidateSolEstAdmin = (respuesta) => {
    PostNotif(`${Url}cantNotifValidateSolEstAdmin`, "", (resp) => {
        let data = JSON.parse(resp);
        let State = {cantNotifValidateSolEstAdmin: data.sol
        }
        respuesta(State);
    });
}

export const ValidateAdmision = (respuesta) => {
    PostNotif(`${Url}cantNotifValidateAdmision`, "", (resp) => {
        let data = JSON.parse(resp);
        let State = {cantNotifValidateAdmision: data.cantNoti}
        respuesta(State);
    });
}

export const ValidatePago = (respuesta) => {
    PostNotif(`${Url}cantNotifValidatePago`, "", (resp) => {
        let data = JSON.parse(resp);
        let State = {cantNotifVerifyPago: data.cantNoti}
        respuesta(State);
    });
}

export const ValidateRetiro = (respuesta) => {
    PostNotif(`${Url}cantNotifValidateRetiro`, "", (resp) => {
        let data = JSON.parse(resp);
        let State = {cantNotifRetiro: data.cantNoti}
        respuesta(State);
    });
}

export const ValidateRetiroAdmin = (respuesta) => {
    PostNotif(`${Url}cantNotifValidateRetiroAdmin`, "", (resp) => {
        let data = JSON.parse(resp);
        let State = {cantNotifRetiroAdmin: data.cantNoti}
        respuesta(State);
    });
}

export const ValidateEmail = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }
        PostNotif(`${Url}ValidateEmail`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });

    })
}

export const EstPendientes = (respuesta) => {
    Post(`${Url}estPendientesInsc`, "", (resp) => {
        let data = JSON.parse(resp);
        respuesta(data[0]);
    });
}

export const EstPendientesFilter = (data, respuesta) => {
    let Content = {
        strings: data
    }

    Post(`${Url}estPendientesInscFilter`, Content, (resp) => {
        let data = JSON.parse(resp);
        respuesta(data[0]);
    });
}

export const DataEstPendientes = (id, respuesta) => {
    let Content= {
        id:id
    }
    Post(`${Url}estPendientesInscData`, Content, (resp) => {
        let data = JSON.parse(resp);
        respuesta([data[0][0]]);
    });
}

export const ConsultaMaterias = (id, respuesta) => {
    let Content = {
        id: id
    }

    Post(`${Url}consultMateriasIns`, Content, (resp) => {
        let data = JSON.parse(resp)
        let contenido = []
        if(data.status === "ok"){
            let cont = data.contenido;
            for (let i in cont){
                let tipo = "";
                
                let contTipos = data.te;
                for (let n in contTipos){
                    if (contTipos[n].id === parseInt(cont[i].tipo_curso)) tipo = contTipos[n].tipoev_name
                }

                /* switch (parseInt(cont[i].tipo_curso)) {
                    case 0:
                        tipo = 'Presencial';
                        break;
                    case 1:
                        tipo = 'Prueba de Suficiencia' ;
                        break;
                    default:
                        tipo = 'Presencial';
                        break;
                } */
                
                contenido.push({
                    id: cont[i].id,
                    materia: cont[i].materia_name,
                    seccion: cont[i].nombre,
                    tipo: tipo,
                    uc: cont[i].u_c,
                    semestre: cont[i].semestre_name
                })
            }
        }
        respuesta(contenido)
    });
}

export const ApruebaInsc = (id, respuesta) => {
    consultaUsuario ((usu) => {
        let contenido = { id: id }
        Post(`${Url}apruebaInsc`, [contenido, usu], (resp) => {
            respuesta (resp)
        });
    });
}

export const NoApruebaInsc = (id, motivo, respuesta) => {
    if (motivo === "") {
        respuesta(false)
    }else{
        consultaUsuario ((usu) => {
            let contenido = {
                id: id,
                motivo: motivo
            }
            Post(`${Url}noApruebaInsc`, [contenido, usu], (resp) => {
                respuesta (true)
            });
        });
    }
}

export const cerrarSesion = () => {
    let leerCookie = (nombre) => {
        let lista = document.cookie.split(";");
        let micookie;
        let igual;
        let valor;
        for (let i in lista) {
          let busca = lista[i].search(nombre);
          if (busca > -1) {micookie=lista[i]}
        }
        
        if (micookie === undefined) return null;
        
        igual = micookie.indexOf("=");
        valor = micookie.substring(igual + 1);
        return valor;
      }

    let valor = leerCookie("U_ID");

    /* let valor = "";
    let lista = document.cookie.split(";");
    for (let i = 0; i <= lista.length; i++){
        if (lista[i] !== undefined) {
            let item = lista[i].split("=");
            if (item[0] === " U_ID"){
                valor = item[1];
            }
        }
    } */

    let Content = {uId: valor,}

    Post(`${Url}cerrarSession`, Content, (resp) => {
      document.cookie =`S_ID=1; max-age=1; path=/`;
      document.cookie =`U_ID=1; max-age=1; path=/`;
      window.location.reload();
    });

}


// WEBPACK FOOTER //
// ./src/funciones/HeaderFunction.jsx